import { useIsAuthenticated } from "@azure/msal-react";
import { useCreatUserInfo } from "lib/userInfo";
import React, { PropsWithChildren } from "react";

const StartupOperations: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  useCreatUserInfo(true);
  return <>{children}</>;
};
export default StartupOperations;
